import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from './Header';
import Dashboard from './Dashboard';
import TeamDashboard from './TeamDashboard';
import ErfolgeTab from './ErfolgeTab';
import GoogleCalendarWidget from './GoogleCalendarWidget';
import LeadsPage from './LeadsPage';
import AppointmentList from './AppointmentList';
import AvailabilityManager from './AvailabilityManager';

// Teamleiter Dashboard with unified navigation
// ===== INNENDIENST DASHBOARD =====


const TeamleiterDashboardWithTabs = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [appointmentSubTab, setAppointmentSubTab] = useState('termine');
  const [apptRefreshKey, setApptRefreshKey] = useState(0);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Leads-Navigation aus Benachrichtigungs-Glocke
  React.useEffect(() => {
    const handler = () => handleTabChange('leads');
    window.addEventListener('navigateToLeads', handler);
    return () => window.removeEventListener('navigateToLeads', handler);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Unified Tab Navigation */}
      <div className="bg-white border-b border-gray-100 shadow-sm sticky top-0 z-40">
        <div className="container mx-auto px-4">
          <nav className="flex space-x-1 overflow-x-auto">
            <button
              onClick={() => handleTabChange('dashboard')}
              data-testid="teamleiter-tab-dashboard"
              className={`flex items-center gap-2 py-3.5 px-3 border-b-2 font-medium text-sm transition-all whitespace-nowrap ${
                activeTab === 'dashboard'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
              Dashboard
            </button>
            <button
              onClick={() => handleTabChange('team')}
              data-testid="teamleiter-tab-team"
              className={`flex items-center gap-2 py-3.5 px-3 border-b-2 font-medium text-sm transition-all whitespace-nowrap ${
                activeTab === 'team'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              {user?.role === 'vertriebsleiter' ? 'Teams verwalten' : 'Team verwalten'}
            </button>
            {user?.role === 'vertriebsleiter' && (
            <button
              onClick={() => handleTabChange('appointments')}
              data-testid="teamleiter-tab-appointments"
              className={`flex items-center gap-2 py-3.5 px-3 border-b-2 font-medium text-sm transition-all whitespace-nowrap ${
                activeTab === 'appointments'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
              Termine
            </button>
            )}
            <button
              onClick={() => handleTabChange('erfolge')}
              data-testid="teamleiter-tab-erfolge"
              className={`flex items-center gap-2 py-3.5 px-3 border-b-2 font-medium text-sm transition-all whitespace-nowrap ${
                activeTab === 'erfolge'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/></svg>
              Erfolge
            </button>
            {user?.role === 'vertriebsleiter' && (
            <button
              onClick={() => handleTabChange('leads')}
              data-testid="teamleiter-tab-leads"
              className={`flex items-center gap-2 py-3.5 px-3 border-b-2 font-medium text-sm transition-all whitespace-nowrap ${
                activeTab === 'leads'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200'
              }`}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/></svg>
              Leads
            </button>
            )}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'dashboard' && (
          <Dashboard 
            showHeader={false} 
            showNavigation={false}
            initialPage="dashboard"
          />
        )}
        {activeTab === 'processes' && (
          <Dashboard 
            showHeader={false} 
            showNavigation={false}
            initialPage="processes"
          />
        )}
        {activeTab === 'appointments' && (
          <div className="container mx-auto px-4 py-8">
            {/* Sub-Tabs for Meine Termine */}
            {user?.role === 'vertriebsleiter' && (
              <div className="flex space-x-1 bg-gray-100 rounded-lg p-1 mb-6 w-fit" data-testid="appointments-sub-tabs">
                <button
                  onClick={() => setAppointmentSubTab('termine')}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    appointmentSubTab === 'termine'
                      ? 'bg-white text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                  data-testid="sub-tab-termine"
                >
                  Termine
                </button>
                <button
                  onClick={() => setAppointmentSubTab('verfuegbarkeiten')}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                    appointmentSubTab === 'verfuegbarkeiten'
                      ? 'bg-white text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                  data-testid="sub-tab-verfuegbarkeiten"
                >
                  Verfügbarkeiten
                </button>
              </div>
            )}
            {appointmentSubTab === 'termine' && (
              <>
                {user?.role === 'vertriebsleiter' && (
                  <GoogleCalendarWidget onSyncComplete={() => setApptRefreshKey(k => k + 1)} />
                )}
                <AppointmentList currentUser={user} refreshKey={apptRefreshKey} />
              </>
            )}
            {appointmentSubTab === 'verfuegbarkeiten' && user?.role === 'vertriebsleiter' && (
              <AvailabilityManager 
                userId={user.id}
                userName={user.name}
              />
            )}
          </div>
        )}
        {activeTab === 'leads' && user?.role === 'vertriebsleiter' && (
          <div className="container mx-auto px-4 py-8">
            <LeadsPage role={user?.role} />
          </div>
        )}
        {activeTab === 'team' && <TeamDashboard />}
        {activeTab === 'erfolge' && user?.role === 'teamleiter' && (
          <Dashboard showHeader={false} showNavigation={false} initialPage="erfolge" />
        )}
        {activeTab === 'erfolge' && user?.role !== 'teamleiter' && (
          <ErfolgeTab role={user?.role} />
        )}
      </div>
    </div>
  );
};

export default TeamleiterDashboardWithTabs;
